module.exports = __webpack_public_path__ + "img/ms-sharepoint.65f64ff6.svg";